import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ek, Jobs, StatusButtons, vk, WebserviceResponse } from "../../../../_shared/interfaces";
import { AlertService, IAlertType, JobsStoreService } from "../../../../_shared/services";
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from "@clr/angular";
import { RouterLink } from "@angular/router";
import { CurrencyPipe, DatePipe, NgIf } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

import * as XLSX from "xlsx";

@Component({
  selector: 'app-jobs-overview',
  standalone: true,
  imports: [
    ClrIconModule,
    ClrDatagridModule,
    RouterLink,
    CurrencyPipe,
    DatePipe,
    NgIf
  ],
  templateUrl: './jobs-overview.component.html',
  styleUrl: './jobs-overview.component.sass'
})

export class JobsOverviewComponent implements OnInit, OnChanges {
  jobs: Jobs[] = [];
  projectID: number = 0;
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() status: string = '';

  statusButtons: StatusButtons[] = [
    { state: '', display: '---', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'confirmed', display: 'Auftrag bestätigt', label: 'alert-info', icon: 'info-circle'},
    { state: 'standard', display: 'Standard', label: 'alert-info', icon: 'info-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'info-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-danger', icon: 'check-circle'},
    { state: 'finished', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor(
      private jobss: JobsStoreService,
      private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit(): void {
    this.loadList(this.status);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loading = true;
    this.loadList(this.status);
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(projectstatus: string) {
    const statusline = this.findButtonStatus(projectstatus, this.statusButtons);
    return {
      'statusLabel' : this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus).statusLabel + " alert-sm";
  }

  loadList(status: string) {
    this.jobss.getJobs('0', 0, status).subscribe({
      next: data => {
        this.jobs = data?.object ?? [];
        if (this.jobs.length === 0) {
          this.alertDispatcher.show({
            message: 'Keine Jobs gefunden.',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.ASC;
      }
    });
  }

  // Calculate EK/VK
  calculateEkVk(projectID: string, jobID: number) {
    let ekvk: object = { ek: 0, vk: 0 };
    // ekvk[0].ek = this.calculateEk(projectID, jobID);
    // ekvk[0].vk = this.calculateVk(projectID, jobID);

    return ekvk;
  }

  // Calculate EK
  calculateEk(projectID: string, jobID: number) {
    let purchasing_sum: number | null = 0;
    this.jobss.calculateEK(projectID, jobID).subscribe( {
      next:  (data: WebserviceResponse<ek>)  => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' EK-Berechnung nicht möglich! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
          return;
        }
        purchasing_sum = data.object[0].ek;
      },
      complete: () => {
        return purchasing_sum
      }
    });
  }

  // Calculate VK
  calculateVk(projectID: string, jobID: number) {
    let selling_sum: number | null = 0;
    this.jobss.calculateVK(projectID, jobID).subscribe( {
      next: (data: WebserviceResponse<vk>)  => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' VK-Berechnung nicht möglich! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
          return;
        }
        selling_sum = data.object[0].vk;
      },
      complete: () => {
        return selling_sum
      }
    });
  }

  exportToExcel(data: any): void {
    // Dokumentation: https://docs.sheetjs.com
    let jobs = data;
    jobs.map((obj: Jobs) => {
      let job = obj as Partial<Jobs>; // Type Assertion
      delete job['street'];
      delete job['city'];
      delete job['postcode'];
      delete job['country'];
      delete job['request_id'];
      delete job['description'];
      job['budget_euro'] = parseFloat(job['budget'] as string);
      delete job['budget'];
      delete job['cond_offer'];
      delete job['cond_payment'];
      delete job['cond_delivery'];
      delete job['delivery_remarks'];
      delete job['status'];
      delete job['employee_phm'];
      delete job['employee_leader'];
      delete job['invoice_company'];
      delete job['invoice_street'];
      delete job['invoice_city'];
      delete job['invoice_postcode'];
      delete job['invoice_country'];
      delete job['delivery_company'];
      delete job['delivery_street'];
      delete job['delivery_city'];
      delete job['delivery_postcode'];
      delete job['delivery_country'];
      delete job['invoice_vat_id'];
    })
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jobs);

    const book: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, worksheet, 'Jobs In Arbeit');

    XLSX.writeFile(book, 'Job-Übersicht.xlsx');
  }

}
